import { render, staticRenderFns } from "./myTicketItem.vue?vue&type=template&id=55fb48d3&scoped=true&"
import script from "./myTicketItem.vue?vue&type=script&lang=js&"
export * from "./myTicketItem.vue?vue&type=script&lang=js&"
import style0 from "./myTicketItem.vue?vue&type=style&index=0&id=55fb48d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb48d3",
  null
  
)

export default component.exports